import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useGoogleAuthenticatorSignIn, useTwillioSignIn } from 'Hooks/Auth';
import { TwoFactorTypes } from 'Interfaces/Auth';
import { UnauthorizedRoutePaths } from 'Interfaces/RoutePaths';
import Toast from 'Services/Toast';
import { selectTwoFactorType } from 'Utils/selectors';

import TwoFactorForm from './components/TwoFactorForm';

const TwoFactor = () => {
  const navigate = useNavigate();
  const twoFactorType = useSelector(selectTwoFactorType);

  if (!twoFactorType) navigate(UnauthorizedRoutePaths.LOGIN);

  const [callSignInTwillio] = useTwillioSignIn();
  const [callSignInGoogleAuthenticator] = useGoogleAuthenticatorSignIn();

  const handleSignIn = useCallback(
    async values => {
      try {
        if (twoFactorType === TwoFactorTypes.TWILLIO) {
          await callSignInTwillio({ code: parseInt(values.code, 10) });
        } else {
          await callSignInGoogleAuthenticator({ code: values.code });
        }
      } catch (error) {
        Toast.handleErrors(error);
      }
    },
    [callSignInGoogleAuthenticator, callSignInTwillio, twoFactorType],
  );

  return <TwoFactorForm onSubmit={handleSignIn} twoFactorType={twoFactorType} />;
};

export default TwoFactor;
